export const NOVA_COTACAO_FORM_ID = "nova-cotacao-form";

export const NOVA_COTACAO_TITULO = "Nova cotação";
export const SALVAR_LABEL = "Salvar";
export const COMPETENCIA_LABEL = "Competência";
export const COMPETENCIA_PLACEHOLDER = "MM/AAAA";
export const MOEDA_LABEL = "Moeda";
export const MOEDA_PLACEHOLDER = "Selecione";
export const MOEDA_BUSCA_PLACEHOLDER = "Buscar por código ou nome";
export const COTACAO_LABEL = "Cotação (R$)";
export const COTACAO_DICA = "Use duas casas decimais.";

/** Primeira competência que pode ser cadastrada: janeiro de 2022. */
export const COMPETENCIA_MINIMA = new Date(2022, 0, 1);

export const CAMPOS_OBRIGATORIOS = "Preencha competência, moeda e cotação";
export const COTACAO_INVALIDA = "Cotação deve ser maior do que zero";

export const COTACAO_CADASTRADA = "Cotação cadastrada com sucesso.";
